
// ─── Permission Groups ────────────────────────────────────────────────────────
export const PERMISSION_GROUPS = [
  {
    label: "Client Management",
    permissions: ["CREATE_CLIENT", "EDIT_CLIENT", "DELETE_CLIENT", "VIEW_CLIENT"],
  },
  {
    label: "Trade Partner",
    permissions: ["MANAGE_TRADE_PARTNER", "VIEW_TRADE_PARTNER"],
  },
  {
    label: "Commission",
    permissions: ["CREATE_COMMISSION", "DOWNLOAD_COMMISSION", "VIEW_COMMISSION"],
  },
  {
    label: "Decommission",
    permissions: ["CREATE_DECOMMISSION", "VIEW_DECOMMISSION"],
  },
  {
    label: "Dispensing",
    permissions: ["DISPENSE_LABEL", "VIEW_DISPENSING"],
  },
  {
    label: "Labels",
    permissions: ["CHECK_LABEL", "VIEW_LABEL", "VIEW_LABEL_TABLE"],
  },
  {
    label: "Packing",
    permissions: ["PACK_LABEL", "DOWNLOAD_PACKING", "VIEW_PACKING"],
  },
  {
    label: "Receiving",
    permissions: ["RECEIVE_LABEL", "VIEW_RECEIVING"],
  },
  {
    label: "Shipping",
    permissions: ["SHIP_LABEL", "VIEW_SHIPPING"],
  },
  {
    label: "Unpacking",
    permissions: ["UNPACK_LABEL", "VIEW_UNPACKING"],
  },
  {
    label: "Location",
    permissions: ["CREATE_LOCATION", "EDIT_LOCATION", "DELETE_LOCATION", "VIEW_LOCATION"],
  },
  {
    label: "User Management",
    permissions: [
      "CREATE_USER", "EDIT_USER", "DELETE_USER", "VIEW_USER",
      "MANAGE_USER_CLIENTS", "MANAGE_USER_ROLES",
    ],
  },
  {
    label: "Role Management",
    permissions: [
      "CREATE_ROLE", "EDIT_ROLE", "DELETE_ROLE", "VIEW_ROLE",
      "MANAGE_ROLE_PERMISSIONS",
    ],
  },
];